import styled from "styled-components";
import { fonts } from "styles";
export const Container = styled.section`
  width: 100%;
  max-width: 1342px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 128px 96px;

  @media screen and (max-width: 580px) {
    padding: 80px 32px;
  }
`;

export const Text = styled.article`
  font-size: 28px;
  line-height: 32px;
  text-align: justify;

  @media screen and (max-width: 1680px) {
    font-size: 24px;
    line-height: 28px;
  }

  @media screen and (max-width: 1440px) {
    font-size: 22px;
    line-height: 26px;
  }

  @media screen and (max-width: 1024px) {
    font-size: 20px;
    line-height: 24px;
  }

  @media screen and (max-width: 580px) {
    font-size: 18px;
    line-height: 22px;
  }

  @media screen and (max-width: 375px) {
    font-size: 16px;
    line-height: 20px;
  }

  @media screen and (max-width: 320px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const Title = styled.h1`
  width: 100%;
  max-width: 470px;
  margin: 124px auto 0 auto;
  font-family: ${fonts.BentonSansWide};
  font-size: 35px;
  line-height: 45px;
  text-align: center;

  @media screen and (max-width: 1680px) {
    font-size: 28px;
    line-height: 38px;
    max-width: 550px;
  }

  @media screen and (max-width: 1440px) {
    font-size: 24px;
    line-height: 34px;
  }

  @media screen and (max-width: 414px) {
    font-size: 14px;
    line-height: 24px;
    margin-top: 48px;
  }

  @media screen and (max-width: 320px) {
    font-size: 10px;
    line-height: 20px;
  }
`;

export const TextSmall = styled.article`
  font-size: 12px;
  line-height: 20px;
  margin-top: 48px;
`;
